module.exports = __webpack_public_path__ + "static/frank-lloyd-wright-25f3259dc5fc431f3fe8c5f747650522.jpg";